import { makeVar } from '@apollo/client'
import { FilterState } from 'views/components/Filters'

export const storeIdsVar = makeVar<number[]>( [] )
export const inventoryLocationIdsVar = makeVar<string[]>( [] )
export const searchVar = makeVar<string>( '' )
export const filtersVar = makeVar<FilterState>( [] )
export const filterContextVar = makeVar<string>( '' )
export const pageVar = makeVar<number>( 0 )

/** Whether the default-store preference has had its say, so a later change is the user's own. */
export const defaultStoresAppliedVar = makeVar<boolean>( false )

export const cacheFields = {
	storeIds: {
		read(): number[] {
			return storeIdsVar()
		},
	},
	inventoryLocationIds: {
		read(): string[] {
			return inventoryLocationIdsVar()
		},
	},
	searchVar: {
		read(): string {
			return searchVar()
		},
	},
	filters: {
		read(): FilterState {
			return filtersVar()
		},
	},
	filterContext: {
		read(): string {
			return filterContextVar()
		},
	},
	page: {
		read(): number {
			return pageVar()
		},
	},
}

export default cacheFields
